/**
 * ShopHelten – Gaveindpakning (Zendesk #35856)
 * Prestige 7 cart-drawer: checkbox toggles a gift-wrap line item (qty always 1).
 */
(function () {
  if (window.__shopheltenGiftWrapInit) return;
  window.__shopheltenGiftWrapInit = true;

  var busy = false;

  function root() {
    return Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/';
  }

  function getSectionsToBundle() {
    var sections = [];
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:prepare-bundled-sections', {
        bubbles: true,
        detail: { sections: sections }
      })
    );
    return sections;
  }

  function dispatchCartChange(cart, baseEvent) {
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:change', {
        bubbles: true,
        detail: { baseEvent: baseEvent || 'shophelten-gift-wrap', cart: cart }
      })
    );
  }

  function findWrap() {
    return document.querySelector('[data-shophelten-gift-wrap]');
  }

  function setBusy(on) {
    busy = !!on;
    var wrap = findWrap();
    if (!wrap) return;
    var input = wrap.querySelector('[data-shophelten-gift-wrap-input]');
    if (input) input.disabled = busy;
    wrap.classList.toggle('is-loading', busy);
  }

  async function addGiftWrap(variantId) {
    var sections = getSectionsToBundle();
    var formData = new FormData();
    formData.set('id', String(variantId));
    formData.set('quantity', '1');
    formData.set('properties[_gift_wrap]', '1');
    formData.set('sections', sections.join(','));
    formData.set('sections_url', root());

    var res = await fetch(root() + 'cart/add.js', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
      body: formData
    });
    var json = await res.json();
    if (!res.ok) throw new Error(json.description || json.message || 'Add failed');

    // cart/add.js returns the line item; fetch cart for full state + merge sections
    var cartRes = await fetch(root() + 'cart.js', { headers: { Accept: 'application/json' } });
    var cart = await cartRes.json();
    if (json.sections) {
      cart.sections = json.sections;
      dispatchCartChange(cart, 'variant:add');
    } else {
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    }
    return cart;
  }

  async function removeGiftWrap(lineKey, variantId) {
    var sections = getSectionsToBundle();
    var payload = {
      quantity: 0,
      sections: sections.join(','),
      sections_url: root()
    };
    if (lineKey) {
      payload.id = lineKey;
    } else {
      payload.id = Number(variantId);
    }

    var res = await fetch(root() + 'cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify(payload)
    });
    var cart = await res.json();
    if (!res.ok) throw new Error(cart.description || cart.message || 'Remove failed');
    dispatchCartChange(cart, 'line-item:change');
    return cart;
  }

  async function ensureQtyOne(lineKey) {
    if (!lineKey) return;
    var sections = getSectionsToBundle();
    var res = await fetch(root() + 'cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        id: lineKey,
        quantity: 1,
        sections: sections.join(','),
        sections_url: root()
      })
    });
    var cart = await res.json();
    if (res.ok) dispatchCartChange(cart, 'line-item:change');
  }

  async function onToggle(event) {
    var input = event.target;
    if (!input || !input.matches || !input.matches('[data-shophelten-gift-wrap-input]')) return;
    if (busy) {
      event.preventDefault();
      return;
    }

    var wrap = input.closest('[data-shophelten-gift-wrap]');
    if (!wrap) return;
    var variantId = wrap.getAttribute('data-variant-id');
    var lineKey = wrap.getAttribute('data-line-key');
    if (!variantId) return;

    setBusy(true);
    try {
      if (input.checked) {
        await addGiftWrap(variantId);
      } else {
        await removeGiftWrap(lineKey, variantId);
      }
    } catch (err) {
      console.error('[shophelten-gift-wrap]', err);
      input.checked = !input.checked;
      var fallback = (wrap && wrap.getAttribute('data-error-message')) || 'Could not update gift wrapping';
      window.alert(err.message || fallback);
    } finally {
      setBusy(false);
    }
  }

  function syncFromDom() {
    var wrap = findWrap();
    if (!wrap) return;
    var input = wrap.querySelector('[data-shophelten-gift-wrap-input]');
    if (!input) return;
    input.checked = wrap.getAttribute('data-in-cart') === 'true';
  }

  document.addEventListener(
    'change',
    function (e) {
      var el = e.target;
      if (!el || !el.matches || !el.matches('input[is="quantity-input"]')) return;
      var wrap = findWrap();
      if (!wrap) return;
      var key = el.getAttribute('data-line-key') || '';
      var gwKey = wrap.getAttribute('data-line-key') || '';
      if (gwKey && key === gwKey && Number(el.value) !== 1) {
        el.value = 1;
        ensureQtyOne(gwKey);
      }
    },
    true
  );

  document.addEventListener('change', onToggle, true);
  document.addEventListener('cart:change', function () {
    setTimeout(syncFromDom, 0);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncFromDom);
  } else {
    syncFromDom();
  }
})();
